<div>
    <div class="row filter_wrapper">
        <div class="col-md-2">
            <p-calendar
                [(ngModel)]="filterDateStart"
                [showIcon]="true"
                (ngModelChange)="changeDateStart($event)"
                dateFormat="dd-mm-yy"
                [minDate]="minDate"
                [maxDate]="dateToday"
                placeholder="Date debut"
                [showButtonBar]="true"
            ></p-calendar>
        </div>
        <div class="col-md-2">
            <p-calendar
                [(ngModel)]="filterDateEnd"
                [showIcon]="true"
                [showClear]="true"
                (ngModelChange)="changeDateEnd($event)"
                dateFormat="dd-mm-yy"
                [minDate]="minDate"
                [maxDate]="dateToday"
                placeholder="Date fin"
                [showButtonBar]="true"
            ></p-calendar>
        </div>
        <div class="col-md-2">
            <div class="form-group">
                <p-dropdown
                    [options]="listSubjects"
                    [(ngModel)]="selectedSubject"
                    [filter]="true"
                    [showClear]="true"
                    placeholder="statut"
                >
                    <ng-template let-data pTemplate="item">
                        <div class="country-item">
                            <div>{{ data | titlecase }}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
        </div>
        <div class="col-md-2">
            <div class="form-group">
                <p-dropdown
                    [options]="listStates"
                    [(ngModel)]="selectedState"
                    [filter]="true"
                    [showClear]="true"
                    placeholder="statut"
                >
                    <ng-template let-data pTemplate="item">
                        <div class="country-item">
                            <div>{{ data | titlecase }}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
        </div>
        <div class="col-md-2">
            <div class="form-group">
                <p-dropdown
                    [options]="listUsers"
                    [(ngModel)]="selectedUser"
                    optionLabel="fullName"
                    [filter]="true"
                    filterBy="nom"
                    [showClear]="true"
                    optionValue="id"
                    placeholder="Selectionner l'utilisateur"
                >
                    <ng-template let-data pTemplate="item">
                        <div class="country-item">
                            <div>{{ data.fullName }}</div>
                        </div>
                    </ng-template>
                </p-dropdown>
            </div>
        </div>
        <div
            [ngStyle]="{ width: '4rem', marginTop: '-1.7rem' }"
            *ngIf="!secondFilter"
        >
            <p-button
                styleClass="p-button-success filter-button"
                icon="pi pi-filter"
                [disabled]="isFilter()"
                (click)="onFilter()"
            ></p-button>
        </div>
    </div>
    <hr [style]="{ margin: '0' }" />
    <div class="table_content_wrapper">
        <div class="d-flex justify-content-between">
            <div class="table_header">
                <app-table-header
                    [count]="listMessages"
                    [legende]="tabsLabel"
                    [page]="page"
                    [totalPage]="totalPage"
                ></app-table-header>
            </div>
            <div class="table_actions_wrapper mb-2">
                <button
                    *ngIf="mappingService.IsAction()"
                    pButton
                    pRipple
                    label="Redigez un message"
                    icon="pi pi-send"
                    class="p-button-success"
                    (click)="onInitForm()"
                ></button>
                <button
                    pButton
                    pRipple
                    label="Rafraîchir"
                    icon="pi pi-refresh"
                    class="p-button-secondary"
                    (click)="OnRefresh()"
                ></button>
                <button
                    pButton
                    pRipple
                    label="Exporter"
                    icon="pi pi-download"
                    class="p-button-helf"
                    [disabled]="disableAction()"
                    (click)="OnExportExcel()"
                ></button>
            </div>
        </div>
        <table [ngClass]="['native_table table']">
            <thead>
                <tr>
                    <th class="text-center">#</th>
                    <th class="text-center" [style]="{ width: '11rem' }">
                        Date d'envoi
                    </th>
                    <th class="text-center">Reference</th>
                    <th class="text-center">Sujet</th>
                    <th class="text-center">Objet</th>
                    <th class="text-center">Statut</th>
                    <th class="text-center">Signature</th>
                    <th class="text-center">Pièce</th>
                    <th class="text-center">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    *ngFor="
                        let data of listMessages
                            | paginate
                                : {
                                      itemsPerPage: recordsPerPage,
                                      currentPage: p,
                                      totalPages: totalPage,
                                      totalItems: totalRecords
                                  };
                        let i = index
                    "
                >
                    <td class="text-center">{{ this.offset + i }}</td>
                    <td>{{ data?.created_at }}</td>
                    <td>{{ data?.reference }}</td>
                    <td (click)="copyData(data.sujet)" style="cursor: pointer">
                        {{ data?.sujet | titlecase }}
                    </td>
                    <td>{{ data?.objet }}</td>
                    <td class="text-center">
                        <span
                            [ngStyle]="{ 'font-size': '16px' }"
                            class="badge"
                            [class.badge-success]="data.statut === 'lu'"
                            [class.badge-dark]="data.statut === 'non-lu'"
                        >
                            {{ data.statut }}
                        </span>
                    </td>
                    <td>
                        {{ data?.signature_nom }}
                        {{ data?.signature_fonction }} [{{
                            data?.signature_contact
                        }}]
                    </td>
                    <td>
                        <button
                            *ngIf="data.piece_jointe"
                            style="height: 2rem"
                            pButton
                            pRipple
                            label="Pièce"
                            icon="pi pi-check"
                            class="p-button-helf"
                        ></button>
                        <button
                            *ngIf="!data.piece_jointe"
                            style="height: 2rem"
                            pButton
                            pRipple
                            label="Aucune"
                            icon="pi pi-ban"
                            class="p-button-warning"
                        ></button>
                    </td>
                    <td class="td-actions">
                        <button
                            pButton
                            icon="pi pi-eye"
                            pTooltip="Voir"
                            tooltipPosition="top"
                            (click)="OnShowMessage(data)"
                            class="p-button-dark"
                        ></button>
                        <button
                            pButton
                            pRipple
                            *ngIf="mappingService.IsAction()"
                            icon="pi pi-pencil"
                            pTooltip="Editer"
                            tooltipPosition="top"
                            (click)="onEditForm(data)"
                            [disabled]="data.statut === 'lu'"
                            class="p-button-secondary"
                        ></button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div [ngClass]="['pagination-controls']">
            <pagination-controls
                (pageChange)="onPageChange($event)"
                previousLabel=""
                nextLabel=""
            >
            </pagination-controls>
        </div>
    </div>
</div>
